import ukUA from 'antd/locale/uk_UA'

import { IAppConfig } from '@/Core/Contracts/Configs/IAppConfig'

import { DATE_FORMAT, DATETIME_FORMAT } from './DateFormat'

export const AppConfig: IAppConfig = {
    /**
     * URL сторінок
     */
    authPageUrl: '/',
    forgotPasswordPageUrl: '/public/forgot-password',
    /**
     * URL бекенду
     */
    backendUrl: import.meta.env['VITE_BACKEND_URL'] || '',
    mercureUrl: import.meta.env['VITE_MERCURE_URL'] || '',
    /**
     * URL Rest запитів
     */
    restLoginUrl: '/services/auth/login?centrifugo=true',
    restUserMe: '/services/auth/me',
    /**
     * Відновлення пароля — код на пошту (`SPEC-005` §3.3). У PD тут стояло
     * скидання за телефоном (`/services/users/password_reset`, SMS), а форма
     * шле `{email}` — тож відновлення не працювало взагалі.
     */
    restForgotPasswordUrl: '/services/users/password_reset_by_email',
    restResetPasswordUrl: '/services/users/{token}/password_reset',
    restRefreshTokenUrl: '/services/auth/refresh_token?centrifugo=true',
    restUserOptionUrl: '/services/user/options',
    /**
     * Ядро цього поля не читає, але контракт `IAppConfig` його вимагає. Тож —
     * справжня адреса глобального пошуку, а не мертвий `typesense/multi_finder`
     * PD (`SPEC-014` §5.3). Шапка кличе її сама (`Ship/Components/UI/Search`).
     */
    searchUrl: '/services/search',
    /**
     * Локалізація
     */
    defaultLocale: import.meta.env['VITE_DEFAULT_LOCALE'] ?? 'uk_UA',
    currentLocale: import.meta.env['VITE_DEFAULT_LOCALE'] ?? 'uk_UA',
    /**
     * Перелік локалей, який вимагає контракт ядра.
     *
     * Була відсутня — конфіг не відповідав `IAppConfig`. Мова в проєкті одна,
     * тож і запис один: ключ збігається з `defaultLocale`, інакше ядро шукало б
     * локаль, якої в мапі немає.
     */
    locales: {
        uk_UA: { configProviderAntdLocale: ukUA },
    },

    /**
     * Дата та час — формат показу, ДД.ММ.РРРР, як в Астеріксі (рішення
     * замовника 2026-10-14). Джерело одне — `./DateFormat`, його ж бере
     * `Ship/Helpers/fieldViews`. На бек дата йде ISO незалежно від цього.
     */
    dateDefaultFormat: DATE_FORMAT,
    datetimeDefaultFormat: DATETIME_FORMAT,
    timezone: 'Europe/Kyiv',
}
